<template>
  <div>
    <div class="card card--white">
      <div class="card card--container">
        <div class="section-headers">
          Choose your {{habitProgram.max_number_of_allowed_groups}} areas of focus
        </div>
        <v-checkbox v-for="aof in areasOfGrowth"
          :label="aof.name"
          v-model="selected"
          :value="aof.id"
          color="success"
          :key="aof.id"
          @change="toggled"></v-checkbox>
        <v-alert type="error" :value="error">
          {{ error }}
        </v-alert>
        <h-btn
           :disabled="loading || selected.length > habitProgram.max_number_of_allowed_groups"
           @click="save">
          Save
        </h-btn>
      </div>
    </div>

    <modal @close="displayModal=false" v-if="displayModal">
      <div slot="body">Woops! Looks like you forgot to select your Areas Of Focus</div>
    </modal>
  </div>
</template>

<script>
import dataStore from "@/services/api/store";
import User from "@/services/api/authUser";
import modal from "@/components/modal";
const HABIT_PROGRAM_STORE = "ClientHabitPrograms";
const AREAS_OF_GROWTH_STORE = "ClientAreasOfGrowth";
const EXERCISE_STORE = "ClientTasks";
const PICKED_AREA_OF_GROWTH_STORE = "ClientAreaOfGrowth";

export default {
  components: {
    modal
  },
  data() {
    return {
      selected: [],
      areasOfGrowth: [],
      error: "",
      habitProgram: {},
      loading: false,
      displayModal: !!this.$route.query.reset_areasOfGrowth
    };
  },
  methods: {
    toggled() {
      if (
        this.selected.length > this.habitProgram.max_number_of_allowed_groups
      ) {
        this.error = `You can only select a max of ${
          this.habitProgram.max_number_of_allowed_groups
        } areas of focus`;
      } else {
        this.error = "";
      }
    },
    save() {
      this.error = false;
      if (
        this.selected.length < this.habitProgram.max_number_of_allowed_groups
      ) {
        this.error = `Please choose all ${
          this.habitProgram.max_number_of_allowed_groups
        } areasOfGrowth`;
        return;
      }
      this.loading = true;
      let promises = this.selected.map((id, i) => {
        return dataStore.create(PICKED_AREA_OF_GROWTH_STORE, {
          theme: id,
          ordering: i
        });
      });
      Promise.all(promises)
        .then(() => dataStore.create(EXERCISE_STORE, {}))
        .then(() => User.setOnBoarded())
        .then(() => this.$router.push("/daily-exercise"))
        .catch(() => (this.loading = false));
    }
  },
  mounted() {
    this.habitProgram = {};
    dataStore
      .findAll(HABIT_PROGRAM_STORE, { assigned: true }, { force: true })
      .then(r => {
        this.habitProgram = r[0];
        dataStore
          .findAll(
            AREAS_OF_GROWTH_STORE,
            { areas_of_focus: this.habitProgram.id },
            { force: true }
          )
          .then(areasOfGrowth => {
            this.areasOfGrowth = areasOfGrowth;
          });
      });
  }
};
</script>
